module.exports = __webpack_public_path__ + "static/media/visa.5f67b7b9.png";